module.exports = __webpack_public_path__ + "static/media/marker-icon-blue.0b46d457.svg";